// 数据处理
 

// 递归
export function TreeData(data) {
  // 检查 data 是否为有效的数组
  if (!Array.isArray(data)) {
    return data;
  }

  for (var i = 0; i < data.length; i++) {
    if (data[i].children == null || data[i].children.length < 1) {
      data[i].children = null;
    } else {
      TreeData(data[i].children);
    }
  }
  return data;
}

// 递归 字段不一样
export function TreeDataKey_trees(data) {
  // 检查 data 是否为有效的数组
  if (!Array.isArray(data)) {
    return data;
  }

  for (let i = 0; i < data.length; i++) {
    if (data[i].trees === null || (Array.isArray(data[i].trees) && data[i].trees.length < 1)) {
      data[i].trees = null;
    } else {
      TreeDataKey_trees(data[i].trees);
    }
  }
  return data;
}